<div class="file-upload">
    <div class="file-drop-area" *ngIf="hasDragArea">
        <span class="fake-btn">{{ 'eui.euifileupload.CHOOSE-FILE' | translate }}</span>
        <span class="file-msg">{{ 'eui.euifileupload.DRAG-AND-DROP-FILE-HERE' | translate }}</span>
        <input
            #input
            class="file-input"
            attr.aria-label= "{{'eui.euifileupload.CHOOSE-FILE' | translate }} 'or' {{ 'eui.euifileupload.DRAG-AND-DROP-FILE-HERE' | translate }}"
            type="file"
            accept="{{ accept }}"
            [multiple]="isMultiple">
    </div>
    <div class="simple-input-file" *ngIf="!hasDragArea">
        <label for="file-{{ randomNumberId }}">
            <eui-button>{{ 'eui.euifileupload.CHOOSE-FILE' | translate }}</eui-button>
        </label>

        <input #input *ngIf="isMultiple" aria-label="Choose Multiple Files" class="file-input" id="file-{{ randomNumberId }}" type="file" accept="{{ accept }}" multiple>
        <input #input *ngIf="!isMultiple" aria-label="Choose a single file" class="file-input" id="file-{{ randomNumberId }}" type="file" accept="{{ accept }}">
    </div>
    <eui-button class="file-upload__reset-button" type="button" (click)="resetList($event)" *ngIf="hasResetButton && files.length > 0">{{ 'eui.euifileupload.RESET-LIST' | translate }}</eui-button>
    <eui-file-upload-progress *ngIf="hasProgressBar" [progress]="progress"></eui-file-upload-progress>

    <div *ngFor="let uploadedFile of uploadedFiles; let i = index">
        <eui-file-preview
            [index]="i"
            [file]="uploadedFile"
            [hasPreview]="hasPreview"
            [hasPreviewAsImage]="hasPreviewAsImage"
            [hasPreviewAsIcon]="hasPreviewAsIcon"
            (removeFromList)="removeFromUploadedList($event)">
        </eui-file-preview>
    </div>

    <div *ngFor="let file of files; let i = index">
        <eui-file-preview
            [index]="i"
            [file]="file"
            [hasPreview]="hasPreview"
            [hasPreviewAsImage]="hasPreviewAsImage"
            [hasPreviewAsIcon]="hasPreviewAsIcon"
            (removeFromList)="removeFromList($event)">
        </eui-file-preview>
    </div>

    <div class="file-upload__total-size" *ngIf="filesTotalSize && hasTotalSizeDisplayed">
        {{ filesTotalSize | filesize }}
    </div>
</div>
